import React, { ReactNode } from 'react';

import { Container, Content, Label, ContentChildren } from './styles';

interface ContainerDateProps {
  children: ReactNode;
  label: string;
}

const ContainerDate: React.FC<ContainerDateProps> = ({ children, label }) => {
  return (
    <Container>
      <Content>
        <Label>{label}</Label>
        <ContentChildren>{children}</ContentChildren>
      </Content>
    </Container>
  );
};

export default ContainerDate;
